import { render } from "./LegacyField.vue?vue&type=template&id=04e2d397"
import script from "./LegacyField.vue?vue&type=script&lang=js"
export * from "./LegacyField.vue?vue&type=script&lang=js"
script.render = render

export default script